import i18n from '@src/i18n';
import { ERROR_CODE } from './constant';
import { Message } from "@cloud/atom-ui";
import webConfig from '../configs/web.config';

// 首尾禁止输入空格
export const whitespaceRule = {
  validator: (_, value) => {
    if (/(^\s+)|(\s+$)/.test(value)) {
      return Promise.reject(new Error(i18n.t('baseInfo:noSpace')))
    }
    return Promise.resolve();
  }
};

// 获取url的参数值
export const queryString = param => {
  const reg = new RegExp("(^|&)" + param + "=([^&]*)(&|$)");
  const r =
    window.location.search.substr(1).match(reg) ||
    window.location.hash
      .substring(window.location.hash.search(/\?/) + 1)
      .match(reg);
  if (r != null) return decodeURIComponent(r[2]);
  return "";
};

export const openUrl = (url) => {
  if (!url) return;
  window.open(url, '_blank', 'noopener,noreferrer');
};

export const downloadFile = (url,fileName) => {
  const xhr = new XMLHttpRequest();
  xhr.open('GET', url, true);
  xhr.responseType = 'blob';
  xhr.onload = function() {
    if (xhr.status === 200) {
      const res = xhr.response;
      const link = document.createElement('a');
      link.style.display = 'none';
      const url = window.URL.createObjectURL(res);
      link.href = url;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      window.URL.revokeObjectURL(link.href);
      document.body.removeChild(link);
    } else {
      console.error('下载失败:', xhr.status);
    }
  };
  xhr.onerror = function() { console.error('下载请求出错'); };
  xhr.send();
}

export const showMessage = (code, message) => {
  let msg = "";
  switch (code) {
    case ERROR_CODE.APPROVE_ERROR:
      msg = i18n.t("approve:approveError");
      break;
    case ERROR_CODE.APPROVE_NO_SUPPORT:
      msg = i18n.t("approve:approveNoSupport");
      break;
    case ERROR_CODE.APPROVE_NO_ENABLED:
      msg = i18n.t("approve:approveNoEnabled");
      break;
    case ERROR_CODE.APPROVE_STATUS_NO_CHANGE:
      msg = i18n.t("approve:approveStatusNoChange");
      break;
    case ERROR_CODE.APPROVE_NO_SUPPORT_OPERATION:
      msg = i18n.t("approve:noSupportOperation");
      break;
    case ERROR_CODE.APPROVE_ID_EMPTY:
      msg = i18n.t("approve:idIsEmpty");
      break;
    case ERROR_CODE.APPROVE_STATUS_EMPTY:
      msg = i18n.t("approve:statusIsEmpty");
      break;
    case ERROR_CODE.APPROVE_ID_NO_FUND:
      msg = i18n.t("approve:idNoFund");
      break;
    case ERROR_CODE.APPROVE_HAS_IN_PROCESS:
      msg = i18n.t("approve:hasInProcess");
      break;
    case ERROR_CODE.APPROVE_NO_APPROVED:
      msg = i18n.t("approve:noApproved");
      break;
    case ERROR_CODE.REPEAT:
      msg = i18n.t('home:nameRepeat');
      break;
    case ERROR_CODE.INVALID:
      msg = i18n.t('home:invalidEAMAP');
      break;
    case ERROR_CODE.LIMITED:
      msg = i18n.t('home:limitEAMAP');
      break;
    case ERROR_CODE.BINDLIMIT:
      msg = i18n.t('baseInfo:bindLimited');
      break;
    case ERROR_CODE.NEEDOWNER:
      msg = i18n.t('baseInfo:ownerAddRole');
      break;
    case ERROR_CODE.NEEDHISOWNER:
      msg = i18n.t('baseInfo:contactHISOwner');
      break;
    default:
      msg = message;
  }
  Message.error(msg);
};

export const getUserInfo = async () => {
  try {
    const userInf = await fetch(webConfig?.userInforUrl, {
      method: "GET",
    })
    return userInf || {};
  } catch (error) {
    return {};
  }
};

// 通用配置
export const getCommonConfig = async (lookupKey) => {
  try {
    const res = await fetch(`${webConfig.getCommonConfig}?lookupKey=${lookupKey}`, {
      method: "GET",
    })
    return res || {};
  } catch {
    return {}
  }
};

// 跳转到开发文档
export const goToDocs = (path) => {
  const openAddress = location.origin.replace('localhost', 'open');
  window.open(`${openAddress}/docs/#${path ? path : ''}`);
};

export const getDefaultLogoList = async () => {
  try {
    const res = await fetch(webConfig?.defaultLogoList, {
      method: "get"
    })
    return res || {};
  } catch {
    return {}
  }
}